import React, { Component } from "react";
import { Admin, Resource } from "react-admin";
import Footer from "./Footer";

import GameList from "./games/GameList";
import GameEdit from "./games/GameEdit";
import GameCreate from "./games/gameCreate/GameCreate";

import LocationList from "./locations/LocationList";
import LocationEdit from "./locations/LocationEdit";

import SchoolList from "./schools/SchoolList";
import SchoolShow from "./schools/SchoolShow";
import SchoolEdit from "./schools/SchoolEdit";
import SchoolCreate from "./schools/SchoolCreate";

import TeamShow from "./teams/TeamShow";
import TeamEdit from "./teams/TeamEdit";
import TeamCreate from "./teams/TeamCreate";

import DistrictList from "./districts/DistrictList";
import DistrictShow from "./districts/DistrictShow";
import DistrictEdit from "./districts/DistrictEdit";
import DistrictCreate from "./districts/DistrictCreate";

import SeasonTeamCreate from "./seasonteams/SeasonTeamCreate";
import SeasonTeamList from "./seasonteams/SeasonTeamList";
import SeasonTeamShow from "./seasonteams/SeasonTeamShow";
import SeasonTeamEdit from "./seasonteams/SeasonTeamEdit";

import PlayerShow from "./players/PlayerShow";
import PlayerEdit from "./players/PlayerEdit";
import PlayerCreate from "./players/PlayerCreate";

import GamePlayerShow from "./gameplayers/GamePlayerShow";
import GamePlayerEdit from "./gameplayers/GamePlayerEdit";
import GamePlayerCreate from "./gameplayers/GamePlayerCreate";

import PersonList from "./people/PersonList";
import PersonShow from "./people/PersonShow";
import PersonEdit from "./people/PersonEdit";

import GameStatsShow from "./gamestats/GameStatsShow";
import GameStatsEdit from "./gamestats/GameStatsEdit";

import SportSeasonList from "./sportseasons/SportSeasonList";
import SportSeasonShow from "./sportseasons/SportSeasonShow";
import SportSeasonEdit from "./sportseasons/SportSeasonEdit";
import SportSeasonCreate from "./sportseasons/SportSeasonCreate";

import NewsgateTransformList from "./newsgatetransforms/NewsgateTransformList";

//import superDataProvider from "./data/providers/superDataProvider";
import unionDataProvider from "./data/providers/unionDataProvider";
import authProvider from "./auth/authProvider";
import customRoutes from "./customRoutes";
import Login from "./Login";
import MyLayout from "./MyLayout";

// gets rid of default hashes in urls
import createHistory from "history/createBrowserHistory";

// get rid of translation errors - only support english for now
import polyglotI18nProvider from "ra-i18n-polyglot";
import englishMessages from "ra-language-english";

import myTheme from "./myTheme";

const history = createHistory();

const messages = {
  en: englishMessages
};

const i18nProvider = polyglotI18nProvider((locale) => messages[locale], "en", {
  allowMissing: true
});

class App extends Component {
  render() {
    const dataProvider = unionDataProvider;

    return (
      <>
        <Admin
          dataProvider={dataProvider}
          authProvider={authProvider}
          loginPage={Login}
          customRoutes={customRoutes}
          history={history}
          locale="en"
          i18nProvider={i18nProvider}
          theme={myTheme}
          layout={MyLayout}
        >
          <Resource
            name="games"
            list={GameList}
            edit={GameEdit}
            create={GameCreate}
          />
          <Resource name="locations" list={LocationList} edit={LocationEdit} />
          <Resource
            name="schools"
            list={SchoolList}
            show={SchoolShow}
            edit={SchoolEdit}
            create={SchoolCreate}
          />
          <Resource name="availableSeasons" />
          <Resource name="sportCodes" />
          <Resource
            name="seasonTeams"
            options={{ label: "Teams" }}
            list={SeasonTeamList}
            show={SeasonTeamShow}
            edit={SeasonTeamEdit}
            create={SeasonTeamCreate}
          />
          <Resource name="comboLocations" />
          <Resource
            name="teams"
            show={TeamShow}
            edit={TeamEdit}
            create={TeamCreate}
          />
          <Resource
            name="districts"
            list={DistrictList}
            show={DistrictShow}
            edit={DistrictEdit}
            create={DistrictCreate}
          />
          <Resource
            name="players"
            show={PlayerShow}
            edit={PlayerEdit}
            create={PlayerCreate}
          />
          <Resource
            name="gamePlayers"
            show={GamePlayerShow}
            edit={GamePlayerEdit}
            create={GamePlayerCreate}
          />
          <Resource
            name="people"
            list={PersonList}
            show={PersonShow}
            edit={PersonEdit}
          />
          <Resource
            name="gamestats"
            show={GameStatsShow}
            edit={GameStatsEdit}
          />
          <Resource
            options={{ label: "Seasons" }}
            name="sportSeasons"
            list={SportSeasonList}
            show={SportSeasonShow}
            edit={SportSeasonEdit}
            create={SportSeasonCreate}
          />
          <Resource
            options={{ label: "Print" }}
            name="newsgateTransforms"
            list={NewsgateTransformList}
          />
        </Admin>
        <Footer />
      </>
    );
  }
}

export default App;
